module.exports = {"id":"182864","name":"Diego Vera","rating":"75","photo":"./data/images/photos/2/182864.png","club":{"name":"Santa Fe","logo":"./data/images/clubs/SantaFe.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DiegoVera0.json
// module id = 1099
// module chunks = 0